<template>
  <div class="ra_index">
      <div class="ra_con">
          <div class="ra_header"><div>排行榜</div></div>
          <div class="ra_list">
              <div class="ra_tab">
                  <div :class="[this.type===1?'active':'']" @click="check(1)">团队里程榜单</div>
                  <div :class="[this.type===2?'active':'']" @click="check(2)">团队积分榜单</div>
              </div>
              <div class="ra_gn" v-if="type===1">
                  <div>
                      <div>我的团队里程</div>
                      <div>截止至{{checktime}}数据统计</div>
                  </div>
                  <div>
                      <div>{{mytotal}} km</div>
                      <div>里程</div>
                  </div>
                  <div>
                      <div>第{{myrank}}位</div>
                      <div>排位</div>
                  </div>
              </div>
              <div class="ra_gn" v-else>
                  <div>
                      <div>我的团队积分</div>
                      <div>截止至{{checktime}}数据统计</div>
                  </div>
                  <div>
                      <div>{{mytotal}} 分</div>
                      <div>积分</div>
                  </div>
                  <div>
                      <div>第{{myrank}}位</div>
                      <div>排位</div>
                  </div>
              </div>
              <div class="ra_rank_item" v-for="item in rankList" :key="item.id">
                  <div class="rank_icon">
                    <template v-if="item.rank <= 3">
                        <img src="@/assets/img/rank/1.png" :alt="item.rank" v-if="item.rank == 1" />
                        <img src="@/assets/img/rank/2.png" :alt="item.rank" v-if="item.rank == 2" />
                        <img src="@/assets/img/rank/3.png" :alt="item.rank" v-if="item.rank == 3" />
                    </template>
                    <span v-else>{{ item.rank }}</span>
                  </div>
                  <div class="rank_user">
                      <div>{{ item.groupname }}</div>
                      <div>截止至{{checktime}}数据统计</div>
                  </div>
                  <div class="rank_btn">
                      <div v-if="type===1">{{item.distance}} km</div>
                      <div v-else>{{item.point}} 分</div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
import { Image, Popup } from "vant";

export default {
  components: {
    VanImage: Image,
    Popup
  },
  name: "hpJoin",
  computed: {
  },
  filters: {
    state(date) {
        return date.slice(5,10);
    }
  },
  data() {
    return {
        rankList: [],
        type: 1,
        checktime: '',
        mytotal: '',
        myrank: ''
    };
  },
  methods: {
    init: function () {
        this.$api.activity.grouprank({matchid:this.$route.params.matchid,type:this.type}).then((res)=>{
            let list = res.data.list
            this.checktime = res.data.checktime?res.data.checktime.slice(5,10):''
            this.myrank = res.data.myrank
            this.mytotal = res.data.mytotal
            if(this.type===1){
                list.forEach((item, index) => {
                    if (index > 0 && +item.distance === +list[index - 1]['distance']) {
                        item.rank = list[index - 1]['rank']
                    } else if (index === 0) {
                        if (this.rankList.length) {
                        let last = this.rankList[this.rankList.length - 1]
                        if (+item.distance === +last.distance) {
                            item.rank = last.rank
                        } else {
                            item.rank = last['rank'] * 1 + 1
                        }
                        } else {
                        item.rank = 1
                        }
                    } else {
                        item.rank = list[index - 1]['rank'] * 1 + 1
                    }
                })
            }else{
                list.forEach((item, index) => {
                    if (index > 0 && +item.point === +list[index - 1]['point']) {
                        item.rank = list[index - 1]['rank']
                    } else if (index === 0) {
                        if (this.rankList.length) {
                        let last = this.rankList[this.rankList.length - 1]
                        if (+item.point === +last.point) {
                            item.rank = last.rank
                        } else {
                            item.rank = last['rank'] * 1 + 1
                        }
                        } else {
                        item.rank = 1
                        }
                    } else {
                        item.rank = list[index - 1]['rank'] * 1 + 1
                    }
                })
            }
            this.rankList = this.rankList.concat(list)
        })
    },
    check(type) {
        this.type = type;
        this.rankList = [];
        this.init();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>

